import { MARD_PALETTE_SOURCE, MARD_SERIES, PALETTE as MARD_PALETTE } from './mard221.js';
import { STANDARD_PALETTE_ID, STANDARD_PALETTE_PROVIDER, STANDARD_SERIES } from './standard.js';

/**
 * Versioned palette-provider registry.
 *
 * The default provider is an internal standard palette. Brand palettes can be
 * registered beside it later, but the UI only presents them as optional
 * compatibility data and never implies official manufacturer approval.
 */
export const DEFAULT_PALETTE_PROVIDER_ID = 'mard-compatible-base-221';

const standard64 = Object.freeze({
  ...STANDARD_PALETTE_PROVIDER,
  labelKey: 'palette.provider',
  series: Object.freeze(Object.keys(STANDARD_SERIES)),
});

const mardCompatibleBase221 = Object.freeze({
  id: 'mard-compatible-base-221',
  labelKey: 'palette.providerMard',
  name: 'MARD-Compatible Base 221',
  colors: MARD_PALETTE,
  source: MARD_PALETTE_SOURCE,
  series: Object.freeze(Object.keys(MARD_SERIES)),
  anchors: Object.freeze({ transparent: 'H1', white: 'H2', black: 'H7' }),
  autoMatchable: (color) => !color.isTransparent,
});

export const PALETTE_PROVIDERS = Object.freeze({
  [standard64.id]: standard64,
  [mardCompatibleBase221.id]: mardCompatibleBase221,
});

export function getPaletteProvider(id = DEFAULT_PALETTE_PROVIDER_ID) {
  return PALETTE_PROVIDERS[id] || mardCompatibleBase221;
}
